<template>
  <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddWorksFlag" size="50%" direction="rtl"
    :before-close="handleClose">

    <div class="demo-drawer__content">

      <el-form :model="addFrom" :rules="rules" ref="ruleForm" v-loading="loading">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="小说名称" :label-width="formLabelWidth" prop="name">
              <el-input v-model="addFrom.name" placeholder="请输入小说名称" style="width: 85%;" :disabled="EditFlag"
                autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="上传封面" :label-width="formLabelWidth" prop="cover">
              <el-upload class="avatar-uploader" action :http-request="(file) => httpRequest(file)"
                accept=".jpg,.png,.jpeg,.bmp,.webp" :show-file-list="false" :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="来源" :label-width="formLabelWidth" prop="source">
              <el-radio-group v-model="addFrom.source">
                <el-radio :label="0">自制</el-radio>
                <el-radio :label="1">版权引入</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="连载状态" :label-width="formLabelWidth" prop="status">
              <el-radio-group v-model="addFrom.status">
                <el-radio :label="0">连载</el-radio>
                <el-radio :label="1">完结</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="addFrom.source == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="版权方" :label-width="formLabelWidth" prop="copyright_id">
              <div style="display: flex;">
                <el-select v-model="addFrom.copyright_id" placeholder="请选择版权方" clearable
                           style="width: 85%;">
                  <el-option v-for="dict in subjectList" :key="dict.id" :label="dict.name" :value="dict.id"/>
                </el-select>
                <img @click="AddPushSubjec"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/xinzeng.png" alt="">
                <img @click="AddRefreshSubjec"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/shuaxin.png" alt="">
              </div>
            </el-form-item>
          </el-col> -->

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="小说状态" :label-width="formLabelWidth">
              <el-radio-group v-model="addFrom.visible">
                <el-radio :label="0">下架</el-radio>
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="2">入库</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="上架时间" :label-width="formLabelWidth">
              <el-date-picker v-model="addFrom.onself_time" type="datetime" placeholder="选择日期时间" align="right"
                value-format="yyyy-MM-dd HH:mm:ss" style="width: 85%;" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="是否开启自然流量" :label-width="formLabelWidth">
              <el-radio-group v-model="addFrom.is_open_zrll">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="章节总数" prop="chapter_total" :label-width="formLabelWidth">
              <el-input v-model="addFrom.chapter_total" placeholder="小说章节总数" style="width: 85%;" clearable disabled
                @input="handleEpisodeTotalInput"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="收费类型" :label-width="formLabelWidth">
              <el-radio-group v-model="addFrom.charge_type">
                <el-radio :label="1">单章收费</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="章节价格" prop="chapter_price" :label-width="formLabelWidth">
              <el-input v-model="addFrom.chapter_price" placeholder="请输入单集价格" style="width: 85%;" clearable
                @input="handlechapter_priceInput"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="免费章节总数" prop="free_chapter_total" :label-width="formLabelWidth">
              <el-input v-model="addFrom.free_chapter_total" style="width: 85%;" placeholder="请输入免费集数总数" clearable
                @input="handlefree_chapte_totalInput"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="剧情描述" prop="description" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="addFrom.description" placeholder="请输入剧情描述" clearable
                :autosize="{ minRows: 2, maxRows: 10 }" style="width: 85%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="addFrom.cansee != 1">
            <el-form-item label="作者" :label-width="formLabelWidth">
              <el-input v-model="addFrom.author" style="width: 85%;" placeholder="请输入作者" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="选择小说分类" prop="trade_type_id" :label-width="formLabelWidth">
              <el-cascader v-model="value" :options="wechatSele" @change="handleChange" style="width: 85%;"></el-cascader>
            </el-form-item>
          </el-col>

          <el-col v-if="addFrom.is_iaa != 0 && addFrom.is_iaa != ''" :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
            class="mb20">
            <el-form-item label="广告优先级" prop="ad_priority" :label-width="formLabelWidth">
              <el-radio-group v-model="addFrom.ad_priority">
                <el-radio :label="1">先充值后广告</el-radio>
                <el-radio :label="2">直接广告</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="渠道是否可见" prop="cansee" :label-width="formLabelWidth">
              <el-radio-group v-model="addFrom.cansee">
                <el-radio :label="0">不可见</el-radio>
                <el-radio :label="1">可见</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="addFrom.cansee != 1">
            <el-form-item label="可见渠道列表" :label-width="formLabelWidth">
              <el-input v-model="addFrom.visible_channels" style="width: 85%;" placeholder="请选择可见渠道列表"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="排序" :label-width="formLabelWidth">
              <el-input v-model.number="addFrom.sequence" style="width: 85%;" placeholder="请输入排序" clearable
                @input="handlesequenceInput"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="AddNone">取 消</el-button>
      <el-button type="primary" @click="addPush" :loading="loading">确 定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { WorksListAPI } from '@/api/Works/WorksList';
import { processErrors } from "@/utils/errorHandler";
import { MoneyManagementAPI } from '@/api/MoneyManagement/MoneyManagement';
import SelectChecked from '@/components/Select/SelectChecked'
import { CastCrewAPI } from '@/api/Works/CastCrew';

export default {
  props: ['AddWorksFlag', "editID"],
  components: {
    SelectChecked
  },
  data() {
    return {
      formLabelWidth: "140px",
      title: "新增",
      addFrom: {
        name: "",
        book_name: "",
        cover: "",
        status: 0,
        source: 0,
        visible: 0,
        charge_type: 1,
        chapter_total: "",
        is_open_zrll: 0,
        is_hot: 0,
        is_new: 0,
        is_collect: 0,
        is_push: 0,
        is_recommend: 0,
        chapter_price: "",
        free_episode_total: "",
        category_1_id: "",
        category_2_id: "",
        category_3_id: "",
        author: "",
        description: "",
        level: "",
        follows_count: "",
        cansee: 0,
        visible_channels: "",
        sequence: "50",
        onself_time: "",
        id: "",
        is_iaa: 0,
        ad_priority: 1,
      },
      rules: {
        cover: [
          { required: true, message: '请选择图片', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入剧情描述', trigger: 'blur' },
        ],
        recommendation: [
          { required: true, message: '请输入推荐语', trigger: 'blur' },
        ],
        episode_total: [
          { required: true, message: '请输入剧集总数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请输入剧集总数'));
              }
              // 使用正则表达式检查是否只包含数字
              const reg = /^[0-9]+$/;
              if (!reg.test(value)) {
                return callback(new Error('请输入有效的数字'));
              }
              callback();
            },
            trigger: 'blur',
          }
        ],
        cansee: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        sequence: [
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入小说名称', trigger: 'blur' },
        ],
        episode_price: [
          { required: true, message: '请输入单集价格', trigger: 'blur' },
        ],
        free_episode_total: [
          { required: true, message: '请输入免费集数总数', trigger: 'blur' },
        ],
        follows_count: [
          { required: true, message: '请输入追剧人数', trigger: 'blur' },
        ],
        copyright_id: [
          { required: true, message: '请选择版权方', trigger: 'change' }
        ],
        produce_year: [
          { required: true, message: '请选择发行年份', trigger: 'change' }
        ],
        production_organisation: [
          { required: true, message: '请输入制作机构', trigger: 'blur' },
        ],
        actor: [
          { required: true, message: '请选择演员', trigger: 'blur' },
        ],
        b_tag_id: [
          { required: true, message: '请选择类目标签', trigger: 'blur' }
        ],
        director: [
          { required: true, message: '请选择导演', trigger: 'blur' },
        ],
        producer: [
          { required: true, message: '请选择制作人', trigger: 'blur' },
        ],
        cost_distribution_uri: [
          { required: true, message: '请上传成本配置比例情况', trigger: 'blur' },
        ],
      },
      nameRole: "优化师",
      appidList: [],
      EditFlag: false,
      imageUrl: "",
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      subjectList: [],
      tagOptions: [],
      isRemoveAllTag: 0,
      cost_distribution_uri: '',
      produceYearList: [],
      directorOptions: [],
      producerOptions: [],
      actorOptions: [],
      active: 1,
      inactive: 0,
      wechatSele: [],
      wechatSeletwo: [],
      wechatSeleTree: [],
      value: []
    };
  },
  created() {
    // this.getclassifyList()
    // this.getSubjectSelect()
    // this.setYearList()
    this.getWechat()

  },
  methods: {
    handleChange(value) {
      this.addFrom.category_1_id=value[0]
      this.addFrom.category_2_id=value[1]
      this.addFrom.category_3_id=value[2]
      console.log(this.addFrom,'addFrom');
    },
    getWechat() {
      let api = WorksListAPI()
      api.wechattype().then(res => {
        if (res.code == 0) {
          this.wechatSele = this.transformToCascaderData(res.data)

          console.log(res, '看看成功后的')
        } else {
          processErrors(res);
        }
      })
    },
    transformToCascaderData(data) {
      return data.map(level1 => ({
        label: level1.name,
        value: level1.type_id,
        children: (level1.erji || []).map(level2 => ({
          label: level2.name,
          value: level2.type_id,
          children: (level2.sanji || []).map(level3 => ({
            label: level3.name,
            value: level3.type_id
          }))
        }))
      }));
    },
    generateRandomFollowCount() {
      // 生成5到6位的随机数
      const min = 10000;  // 五位数的最小值
      const max = 999999; // 六位数的最大值
      const numLength = Math.random() < 0.5 ? 5 : 6; // 随机选择生成五位数或六位数
      const lowerBound = Math.pow(10, numLength - 1);  // 根据选择的位数设置最小值
      const upperBound = Math.pow(10, numLength) - 1;  // 设置最大值
      return Math.floor(Math.random() * (upperBound - lowerBound + 1)) + lowerBound;
    },
    handleEpisodeTotalInput(value) {
      // 强制只允许输入数字
      this.addFrom.episode_total = value.replace(/[^\d]/g, ''); // 使用正则表达式替换非数字字符
    },
    handlechapter_priceInput(value) {
      // 强制只允许输入数字
      this.addFrom.chapter_price = value.replace(/[^\d]/g, ''); // 使用正则表达式替换非数字字符
    },
    handlefree_chapte_totalInput(value) {
      // 强制只允许输入数字
      this.addFrom.free_chapter_total = value.replace(/[^\d]/g, ''); // 使用正则表达式替换非数字字符
    },
    handlefollows_countlInput(value) {
      // 强制只允许输入数字
      this.addFrom.follows_count = value.replace(/[^\d]/g, ''); // 使用正则表达式替换非数字字符
    },
    handlesequenceInput(value) {
      // 强制只允许输入数字
      this.addFrom.sequence = value.replace(/[^\d]/g, ''); // 使用正则表达式替换非数字字符
    },
    handleAvatarSuccess(res, file) {
      this.addFrom.cover = URL.createObjectURL(file.raw);
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error('上传封面大小不能超过 1MB!');
      }
      return isLt2M
    },

    /**
     * 获取抖音类目标签列表
     */
    getTagOptions() {
      let api = WorksListAPI()
      api.getTags().then((res) => {
        let data = res.data;
        this.tagOptions = data.map(item => ({
          value: item.tag_id,
          label: item.tag_name,
          check: false
        }));

        if (this.addFrom && this.addFrom.b_tag_id) {
          // 将逗号分隔的字符串转换为数组
          const b_tag_idValues = this.addFrom.b_tag_id.split(',').map(Number); // 转换为数字数组

          this.tagOptions.forEach(b_tag_id => {
            if (b_tag_idValues.includes(b_tag_id.value)) {
              b_tag_id.check = true; // 如果包含，设置 check 为 true
            }
          });
        }

      });
    },

    getCastCrewOptions() {
      let api = CastCrewAPI();
      let params = {
        pageNo: 1,
        pageSize: 99999,
      };

      api.getCastCrewList(params).then(res => {
        if (res.code === 0) {
          let data = res.data.data;

          // 检查 data 是否为数组
          if (!Array.isArray(data)) {
            console.error('Expected data to be an array, but got:', data);
            return; // 如果不是数组，直接返回
          }

          // 初始化三个数组
          this.directorOptions = [];
          this.producerOptions = [];
          this.actorOptions = [];

          // 按类型分组数据
          data.forEach(item => {
            const option = {
              value: item.id,
              label: item.name,
              check: false
            };

            switch (item.type) {
              case 1: // 导演
                this.directorOptions.push(option);
                break;
              case 2: // 制作人
                this.producerOptions.push(option);
                break;
              case 3: // 演员
                this.actorOptions.push(option);
                break;
              default:
                break; // 处理其他类型（如果有）
            }
          });

          if (this.addFrom && this.addFrom.director) {
            // 将逗号分隔的字符串转换为数组
            const directorValues = this.addFrom.director.split(',').map(Number); // 转换为数字数组

            this.directorOptions.forEach(director => {
              if (directorValues.includes(director.value)) {
                director.check = true; // 如果包含，设置 check 为 true
              }
            });
          }

          if (this.addFrom && this.addFrom.producer) {
            // 将逗号分隔的字符串转换为数组
            const producerValues = this.addFrom.producer.split(',').map(Number); // 转换为数字数组

            this.producerOptions.forEach(producer => {
              if (producerValues.includes(producer.value)) {
                producer.check = true; // 如果包含，设置 check 为 true
              }
            });
          }

          if (this.addFrom && this.addFrom.actor) {
            // 将逗号分隔的字符串转换为数组
            const actorValues = this.addFrom.actor.split(',').map(Number); // 转换为数字数组

            this.actorOptions.forEach(actor => {
              if (actorValues.includes(actor.value)) {
                actor.check = true; // 如果包含，设置 check 为 true
              }
            });
          }
        } else {
          processErrors(res);
        }
      }).catch(error => {
        console.error('Error fetching cast crew list:', error);
      });
    },

    //选择抖音类目
    selectedTags(value) {
      this.addFrom.b_tag_id = value.join(',');
    },

    //选择导演
    selectedDirector(value) {
      this.addFrom.director = value.join(',');
    },

    //选择制作人
    selectedProducer(value) {
      this.addFrom.producer = value.join(',');
    },

    //选择演员
    selectedActor(value) {
      this.addFrom.actor = value.join(',');
    },

    /**
     * 设置年份列表
     */
    setYearList() {
      const currentYear = new Date().getFullYear(); // 获取当前年份
      this.produceYearList = []; // 清空数组
      for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        this.produceYearList.push({ id: i + 1, name: year }); // 添加对象到数组
      }

    },

    httpDistributionRequest(file) {
      let api = WorksListAPI()
      this.cost_distribution_uri = new FormData();
      this.cost_distribution_uri.append("file", file.file);

      api.fileDistributionUpload(this.cost_distribution_uri).then((res) => {
        if (res.code == 0) {
          this.cost_distribution_uri = res.data.url_full;
          this.addFrom.cost_distribution_uri = res.data.url;
        } else {
          processErrors(res);
        }
      });
    },

    handleDistributionSuccess(res, file) {
      this.addFrom.cost_distribution_uri = URL.createObjectURL(file.raw);
    },

    httpRequest(file) {
      let api = WorksListAPI()
      let arrImg = new FormData()

      arrImg.append("file", file.file);

      api.fileUpload(arrImg).then((res) => {
        if (res.code == 0) {
          this.imageUrl = res.data.url_full;
          this.addFrom.cover = res.data.url;
        } else {
          processErrors(res);
        }
      });
    },
    /**
     * 获取版权方列表
     */
    getSubjectSelect() {
      let api = MoneyManagementAPI()
      api.getSubjectSelect().then(res => {
        if (res.code == 0) {
          this.subjectList = res.data
        } else {
          processErrors(res);
        }
      })
    },

    getContractSelect(subject_id) {
      this.contractList = [];
      let api = MoneyManagementAPI()
      api.getContractSelect({ subject_id: subject_id }).then(res => {
        if (res.code == 0) {
          this.contractList = res.data

        } else {
          processErrors(res);
        }
      })
    },

    AddPushSubjec() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/MoneyManagement/subject';
      window.open(url);
    },

    AddRefreshSubjec() {
      this.getSubjectSelect()
    },

    getclassifyList() {
      let api = WorksListAPI()
      api.classifyList(this.page).then(res => {
        if (res.code == 0) {
          this.appidList = res.data
        } else {
          processErrors(res);
        }
      })
    },
    handleClose(done) {
      this.$emit('NoneDlog')
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.addFrom = {
        name: "",
        cover: "",
        source: "",
        visible: "",
        episode_total: "",
        is_open_zrll: "",
        episode_price: "",
        free_episode_total: "",
        description: "",
        level: "",
        follows_count: "",
        cansee: "0",
        visible_channels: "",
        sequence: "",
        copyright_id: "",
        onself_time: "",
        id: "",
        is_iaa: 0,
        ad_priority: 1
      }
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          let api = WorksListAPI()
          if (this.addFrom.id == "") {
            api.WorksAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
              }

            })
          } else {
            api.WorksAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
              }

            })
          }
          this.loading = false;
        } else {

          return false;
        }
      });
    },
    Addactor() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/WorksManagement/CastCrew';
      window.open(url);
    },
    AddRefreshActor() {
      this.getCastCrewOptions()
    }
  },

  mounted() {
    if (this.editID != "") {
      this.loading = true;
      let api = WorksListAPI()
      api.detailsList(this.editID).then(res => {
        if (res.code == 0) {
          this.imageUrl = res.data.full_cover
          this.cost_distribution_uri = res.data.full_cost_distribution_uri
          this.title = "编辑"
          this.addFrom = res.data
          this.addFrom.tags = res.data.tags.join(',')

          this.addFrom.is_iaa = res.data.is_iaa == null ? 0 : res.data.is_iaa
          this.addFrom.ad_priority = res.data.ad_priority == null ? 1 : res.data.ad_priority

          // this.getCastCrewOptions();
          // this.getTagOptions();

          this.loading = false;
        } else {
          processErrors(res);
        }
      })
    } else {
      // this.getCastCrewOptions()
      // this.getTagOptions()
      // this.addFrom.follows_count = this.generateRandomFollowCount()
    }

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  //flex: 1; /* 让按钮平分容器宽度 */
  width: 320px;
  /* 设置按钮宽度为120px */
}

.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>